import { Modal } from '../../../../core/components/templates/Modal';
import Player from '../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../core/constants/modal-videos';

interface SimuladoInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function SimuladoInfoModal({ isOpen, onClose }: SimuladoInfoModalProps) {
  if (!MODAL_VIDEOS_VIMEO_ALLOWED.SIMULADO_ENEM.token) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      title={'Sobre os Simuladões'}
    >
      <Player
        playerType='modalVideo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.SIMULADO_ENEM.token}
        initialTime={0}
      />
    </Modal>
  );
}

export { SimuladoInfoModal };
